<style>
</style>
<template>
    <v-container fluid id="my--orders">
        <v-container fluid style="max-width: 960px;">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="items"
                class="mt-4 mb-4"
                item-key="basketId"
                single-expand
                show-expand
                :expanded.sync="expanded"
                :sort-by="sortBy"
                :sort-desc="[true, true]"
            >
                <template v-slot:item.createTime="{ item }">{{ item.createTime | moment('D.M.Y HH:mm:ss') }}</template>
                <template v-slot:item.items="{ item }">
                    {{ item.items !== null && item.items !== undefined ? item.items.length : 0 }}
                </template>
                <template v-slot:item.totalAmount="{ item }">{{ item.totalAmount | currency }}</template>
                <template v-slot:item.orders="{ item }">
                    <my-orders-options :item="item"></my-orders-options>
                </template>

                <template v-slot:expanded-item="{ item }">
                    <td colspan="10">
                        <v-row wrap row v-for="i in item.items" :key="i.itemId">
                            <v-col xs2>
                                <small class="grey--text">{{ $t('Název') }}</small>
                                <div>{{ i.itemName }}</div>
                            </v-col>
                            <v-col xs="6" class="hidden-xs-only">
                                <small class="grey--text">{{ $t('Položka') }}</small>
                                <div>{{ i.itemDesc }}</div>
                            </v-col>
                            <v-col xs2 class="text-center">
                                <small class="grey--text">{{ $t('Množství') }}</small>
                                <div>{{ i.volume }}</div>
                            </v-col>
                            <v-col xs2 class="text-left" v-if="i.totalCredit && i.totalCredit > 0">
                                <small class="grey--text">{{ $t('Kredit') }}</small>
                                <div>{{ i.totalCredit | currency }}</div>
                            </v-col>
                            <v-col xs2 class="text-left" v-else>
                                <small class="grey--text">{{ $t('Cena') }}</small>
                                <div>{{ i.total | currency }}</div>
                            </v-col>
                        </v-row>
                    </td>
                </template>
            </v-data-table>
        </v-container>
        <!--    <v-row class="background: grey lighten-1">-->
        <!--      <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
        <!--      <v-alert type="info" color="grey lighten-1">{{ $t('Zde najdete přehled svých objednávek') }}</v-alert>-->
        <!--      </v-container>-->
        <!--    </v-row>-->
    </v-container>
</template>
<script>
import DisplayGroupMixin from '@/mixins/display-group-mixin'
import BasketMixin from '@/mixins/basket-mixin.js'
import MyOrdersOptions from '@/components/my-orders-options.vue'

export default {
    props: {
        orders: {
            type: Array,
            default: null
        }
    },
    mixins: [DisplayGroupMixin, BasketMixin],
    components: {
        MyOrdersOptions
    },
    data() {
        return {
            selectedCard: null,
            expanded: [],
            sortBy: ['createTime', 'receiptNo'],
            headers: [{
                text: 'Datum',
                value: 'createTime',
                sortable: true
            }, {
                text: 'Č. objednávky',
                value: 'receiptNo'
            }, {
                text: 'Položek',
                value: 'items'
            }, {
                text: 'Částka',
                value: 'totalAmount'
            }, {
                text: 'Stav',
                value: 'stateDescription'
            }, {
                text: 'Možnosti',
                value: 'orders'
            }],
            // pagination: {
            //     'sortBy': 'createTime',
            //     'descending': false,
            //     'rowsPerPage': 10
            // }
        }
    },
    computed: {
        loading() {
            return this.orders === null
        },
        items() {
            return this.orders !== null ? this.orders : []
        }
    }
}
</script>
